<template>
    <div class="pt40 pb40" style="background-color: #fff;">
        <h3 class="tac title-text mb20" style="font-size: 18px;">
            <i class="el-icon-lock text-bold" style="font-size: 60px;vertical-align: middle;"></i>
            <span class="tip-text pl10">页面无权限，如需查看请进行权限申请</span>
        </h3>
        <div class="tips-info clear-both ">
            <div class="img-info fl">
                <img src="@/assets/img/401.gif" class="tip-img" alt="">
            </div>
            <div class="page-info fl mt60">
                <h4 class="mb10">页面说明</h4>
                <div class="mb20 pl20">
                    <slot>
                        <p>{{info}}</p>
                    </slot>
                </div>
                <h4 class="mb10">权限申请流程</h4>
                <div class="pl20">
                    <p>登录致远OA系统  —>  选择综合审批  —>  IT类流程审批  —>  权限申请</p>
                    <p>权限申请中选择【聚投】</p>
                    <p>权限申请说明填写：因【何事（需要清晰明了描述需求场景）】需要申请【什么页面/功能/数据权限】</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "noPermissionInfo",
        props:{
            info:{
                type:String,
                default:'页面权限未开通',
            }
        }
    }
</script>

<style scoped>
    .title-text {
        color: #02a7f0;
    }

    .tips-info{
        width: 850px;
        margin: 50px auto 0;
    }
    .tip-text {
        letter-spacing: 1px;
    }

    .tip-img {
        max-width: 280px;
    }
</style>
